import Model from "./Model.js";

/**
 * Contact information model.
 *
 * @param {string} spec - Model configuration
 * @param {string} spec.name - Full name (e.g. John Doe)
 * @param {string} spec.postalAddress - Zip code & City
 * @param {string} spec.address - Street name etc
 * @param {string} spec.phone - Phone number
 * @param {string} spec.customerManager - An identifier for a person responsible for the receiver
 * @param {string} spec.email -
 * @return {contactInfo}
 */
export default class ContactInfo extends Model {
	constructor({
		name,
		address,
		postalAddress,
		phone,
		customerManager,
		email,
	} = {}) {
		super(...arguments);

		this._name = name;
		this._address = address;
		this._postalAddress = postalAddress;
		this._phone = phone;
		this._customerManager = customerManager;
		this._email = email;
	}

	getName() {
		return this._name;
	}

	setName(newName) {
		this._name = newName;
	}

	getAddress() {
		return this._address;
	}

	setAddress(newAddress) {
		this._address = newAddress;
	}

	getPostalAddress() {
		return this._postalAddress;
	}

	setPostalAddress(newPostalAddress) {
		this._postalAddress = newPostalAddress;
	}

	getPhone() {
		return this._phone;
	}

	setPhone(newPhone) {
		this._phone = newPhone;
	}

	getCustomerManager() {
		return this._customerManager;
	}

	setCustomerManager(customerManager) {
		this._customerManager = customerManager;
	}

	getEmail() {
		return this._email;
	}

	setEmail(email) {
		this._email = email;
	}

	toString() {
		return this._name || "";
	}

	_serializedProperties() {
		return {
			name: this._name,
			address: this._address,
			postalAddress: this._postalAddress,
			phone: this._phone,
			customerManager: this._customerManager,
			email: this._email,
		};
	}
}
